export const ACCEPT =
  "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,image/*,.docx,.odt,.pdf,.png,.jpg,.jpeg,.webp";

export const MAX_TEXT_CHARS = 12000;
export const MAX_FILES = 10;

export const looksLikeUrl = (u) => /^https?:\/\/\S+/i.test(u);

export const formatBool = (v) =>
  typeof v === "boolean" ? (v ? "Yes" : "No") : "-";

export const formatConfidence = (v) =>
  typeof v === "number" ? `${Math.round(v * 100)}%` : "-";

export const renderList = (arr, empty = "-") =>
  Array.isArray(arr) && arr.length ? (
    <ul style={{ margin: 0, paddingLeft: 18 }}>
      {arr.map((x, i) => (
        <li key={`${x}-${i}`}>{x}</li>
      ))}
    </ul>
  ) : (
    <span>{empty}</span>
  );

export const toggleValue = (value, setter) => {
  setter((prev) =>
    prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
  );
};

const pickFirst = (...vals) => {
  for (const v of vals) {
    if (v === null || v === undefined) continue;
    if (typeof v === "string" && v.trim() === "") continue;
    if (Array.isArray(v) && v.length === 0) continue;
    if (
      typeof v === "object" &&
      !Array.isArray(v) &&
      Object.keys(v).length === 0
    )
      continue;
    return v;
  }
  return null;
};

const summariseReviewItems = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  // Return a compact array you can render nicely in UI
  return items.map((it) => ({
    itemKey: it?.itemKey || "",
    context: it?.context || "",
    notes: it?.notes || "",
    updatedAt: it?.updatedAt || "",
  }));
};

// Context can exist per uploaded item on admin side (attempt.review.items)
export const getAttemptContext = (a) => {
  const items = summariseReviewItems(a?.review?.items);
  if (items) return items;

  return pickFirst(
    a?.context,
    a?.ai?.context,
    a?.ai?.fpContext,
    a?.meta?.context,
    a?.input?.context,
  );
};

export const getAttemptNotes = (a) => {
  const items = summariseReviewItems(a?.review?.items);
  if (items) return items;

  return pickFirst(
    a?.notes,
    a?.reviewerNotes,
    a?.reviewer?.notes,
    a?.ai?.notes,
    a?.meta?.notes,
  );
};

export const hasAttemptMedia = (a) => {
  const input = a?.input || {};
  return Boolean(
    input?.url ||
    input?.text ||
    (Array.isArray(input?.files) && input.files.length) ||
    (Array.isArray(input?.media) && input.media.length) ||
    input?.storagePath ||
    input?.storagePaths ||
    (Array.isArray(a?.media) && a.media.length) ||
    a?.fileUrl ||
    (Array.isArray(a?.fileUrls) && a.fileUrls.length),
  );
};